import { HotKeyReserved } from "../../models/fastRepliesHotKeys"

export const FirstKeys = {
    SHIFT: 16,
    CTRL: 17,
    ALT: 18
}

const enterCode = 13
const reservedCharsWithControl = [67, 86, 65, 90, 88, 89, 37, 39, 66, 73, 85, 36, 35, enterCode]
const reservedCharsWithAlt = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57]

export const ReservedCombinations: HotKeyReserved[] = [
    {
        firstKey: FirstKeys.CTRL,
        secondKeys: reservedCharsWithControl
    },
    {
        firstKey: FirstKeys.SHIFT,
        secondKeys: [enterCode]
    },
    {
        firstKey: FirstKeys.ALT,
        secondKeys: reservedCharsWithAlt
    }
]

export const keyMapping: Record<string, { en: string; ru: string }> = {
    q: { en: "q", ru: "й" },
    w: { en: "w", ru: "ц" },
    e: { en: "e", ru: "у" },
    r: { en: "r", ru: "к" },
    t: { en: "t", ru: "е" },
    y: { en: "y", ru: "н" },
    u: { en: "u", ru: "г" },
    i: { en: "i", ru: "ш" },
    o: { en: "o", ru: "щ" },
    p: { en: "p", ru: "з" },
    "[": { en: "[", ru: "х" },
    "]": { en: "]", ru: "ъ" },
    a: { en: "a", ru: "ф" },
    s: { en: "s", ru: "ы" },
    d: { en: "d", ru: "в" },
    f: { en: "f", ru: "а" },
    g: { en: "g", ru: "п" },
    h: { en: "h", ru: "р" },
    j: { en: "j", ru: "о" },
    k: { en: "k", ru: "л" },
    l: { en: "l", ru: "д" },
    ";": { en: ";", ru: "ж" },
    "'": { en: "'", ru: "э" },
    z: { en: "z", ru: "я" },
    x: { en: "x", ru: "ч" },
    c: { en: "c", ru: "с" },
    v: { en: "v", ru: "м" },
    b: { en: "b", ru: "и" },
    n: { en: "n", ru: "т" },
    m: { en: "m", ru: "ь" },
    ",": { en: ",", ru: "б" },
    ".": { en: ".", ru: "ю" },
    "/": { en: "/", ru: "." },
    "`": { en: "`", ru: "ё" }
}
